import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageLeave, pageView } from '@utils/analytics/telemetry';
import { scrubPathPII } from '@utils/analytics/sanitize';

// Pageview centralizado: dispara EXACTAMENTE un pageview por cambio de ruta.
// Se monta una sola vez por árbol de rutas (en cada Layout), reaccionando a
// useLocation. Reemplaza el pageview que vivía en useTracking, el cual se montaba
// en ~47 componentes y multiplicaba los pageviews por navegación.
const usePageView = (): void => {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    // La ruta se sanea ANTES de salir de la app: hay pantallas cuyo parámetro es un dato personal
    // del cliente final (la bandeja de WhatsApp direcciona por el teléfono del contacto), y sin
    // esto ese número se publica tal cual en GA4. Ver `scrubPathPII`.
    pageView(posthog, {
      page_path: scrubPathPII(location.pathname),
      page_location: scrubPathPII(window.location.href),
      page_title: document.title,
    });
    return () => {
      pageLeave(posthog);
    };
    // Solo el pathname determina un nuevo pageview (no query/hash).
  }, [location.pathname]);
};

export default usePageView;
